module.exports = "/img/30.10b3c6.webp";